<template>
  <div v-loading="isLoading">
    <p>{{ audioPermissionStatus }}</p>
    <p v-if="isAudioPermission">{{ timeCountdown }}秒後更新</p>

    <div v-if="isAudioPermission" class="area-grid">
      <div
        v-for="area in areaBlocks"
        :key="area._id || area.name"
        v-show="showArea(area)"
        :class="['area-card', { expanded: isExpanded(area) }]"
      >
        <area-block
          :ref="area.name"
          :area="area"
          :use_chart_btn="true"
          :alert="alert"
          :close_alert="close_alert"
          :selectedProject="selectedProject"
          @toggle="onToggle(area)"
          @status-change="onStatusChange"
        />
      </div>
    </div>

    <div v-else><el-button @click="openOCC()">啟用OCC頁面</el-button></div>
    <audio src="../assets/Alarm.wav" id="audioElement"></audio>
  </div>
</template>


<script>
//import { dotList, getStatusColor } from '@/lib/base/systemAlert';
import AreaBlock from '../components/occ/AreaBlock.vue';

export default {
  components: {
    AreaBlock,
  },
  props: {
    useUrl: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      project:null,
      autoRefresh: false,
      isLoading: true,
      areaBlocks: [],
      use_chart_btn: false,
      audioPermissionStatus:'',
      isAudioPermission: false,

      alertFlag: false,
      alertList: [],

      timeCountdown: 0,
      refreshFunc: null,

      //expandedSet: new Set(),     // 用來記錄「哪些卡片是展開」
      expandedOrder: [],          // （可選）想要「最新展開」排最上就維護這個

      areaStatusMap: {},   // { [areaIdOrName]: 'GREEN' | 'AL' | 'WL' | 'WSL' | 'down' }
    };
  },
  computed: {
    timezone() {
      return this.$store.getters['env/timezone'];
    },
    selectedProject() {
      if(this.project) return this.project;
      return this.$store.getters['project/selectedProject'];
    },
    isNotOCCUser() {
      return this.$store.getters['user/details'].roles != 'occ';
    },

    sortedAreas() {
      //// 如果你要「最新展開在最上面」，就用 expandedOrder 來排序
      //if (this.expandedOrder.length) {
      //  const map = new Map(this.areaBlocks.map(a => [a._id || a.name, a]));
      //  const expanded = this.expandedOrder
      //    .map(id => map.get(id))
      //    .filter(Boolean); // 只保留存在的
      //  const others = this.areaBlocks.filter(a => !this.expandedSet.has(a._id || a.name));
      //  return [...expanded, ...others];
      //}
      //
      //// 一般情況：展開的在前、其他在後（維持原本相對順序）
      //const expanded = [];
      //const others = [];
      //for (const a of this.areaBlocks) {
      //  (this.expandedSet.has(a._id || a.name) ? expanded : others).push(a);
      //}
      //return [...expanded, ...others];

      if (!this.expandedOrder.length) return this.areaBlocks;

      const idOf = a => a._id || a.name;

      const map = new Map(this.areaBlocks.map(a => [idOf(a), a]));
      const expanded = this.expandedOrder.map(id => map.get(id)).filter(Boolean);
      const expandedSet = new Set(this.expandedOrder);
      const others = this.areaBlocks.filter(a => !expandedSet.has(idOf(a)));
      return [...expanded, ...others];
    },
  },
  beforeDestroy() {
    clearInterval(this.refreshFunc);
  },
  mounted() {
    if(this.useUrl){
      //console.log('using url!');
      this.setProject()
        .then(() => {
          this.init();
        });
    }
    else{
      //console.log('didnt use url!');
      this.init();
    }
  },
  methods: {
    async requestLocationPermission() {
      this.audioPermissionStatus = '音訊權限未授予';
      this.isAudioPermission = false;

      try{
        // 创建一个 AudioContext 对象
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();

        // 尝试创建静默音频
        const buffer = audioContext.createBuffer(1, 1, 22050);
        const source = audioContext.createBufferSource();
        source.buffer = buffer;
        source.connect(audioContext.destination);

        // 尝试播放静默音频（实际上不会播放声音）
        source.start(0);

        // 处理音频上下文的状态
        audioContext.resume().then(() => {
          console.log('音频权限已授予');
          this.audioPermissionStatus = '音訊權限已授予';
          this.isAudioPermission = true;
        });
      }
      catch(error){
        console.error('無法獲取音頻權限', error);
        this.audioPermissionStatus = '音訊權限未授予';
      }
    },
    setProject() {
      return this.$axios({
        category: 'project',
        method: 'get',
        apiName: '',
        useUrl: 'https://api-thsr-rain.geosupply.com.tw/',
      })
        .then(res => {
          if (res && res.data && res.data.length > 0) {
            this.project = res.data[0];
          }
        })
        .catch(err => {
          console.error('setProject failed:', err);
          this.$notifyError && this.$notifyError(err);
        });
    },
    async init() {
      this.isLoading = true;
      try {
        await this.getInstrumentsAndAreas();
      } catch (error) {
        console.error('Initial data fetch failed:', error);
      } finally {
        this.isLoading = false;
      }
      
      await this.requestLocationPermission();

      const envInterval = process.env.VUE_APP_OCC_REFRESH_INTERVAL;
      const refreshInterval = envInterval ? parseInt(envInterval, 10) : 60 * 5;
      this.timeCountdown = refreshInterval;
      
      if (this.refreshFunc) clearInterval(this.refreshFunc);
      
      this.refreshFunc = setInterval(() => {
        if (!this.isAudioPermission) return;
        this.timeCountdown = this.timeCountdown - 1;
        if (this.timeCountdown <= 0) {
          console.log('occ update triggered');
          this.updateAllAreas();
          this.timeCountdown = refreshInterval;
        }
      }, 1000 * 1);
    },
    updateAllAreas() {
      for (let area of this.areaBlocks) {
        try {
          const areaRef = this.$refs[area.name];
          if (areaRef && areaRef[0] && typeof areaRef[0].update === 'function') {
            areaRef[0].update();
          }
        } catch (e) {
          console.error(`Failed to update area ${area.name}:`, e);
        }
      }
    },
    async getInstrumentsAndAreas() {
      try {
        if (!this.selectedProject || !this.selectedProject._id) {
          console.warn('No project selected for getInstrumentsAndAreas');
          return;
        }
        let res = await this.$axios({
          category: 'occ',
          method: 'get',
          apiName: `${this.selectedProject._id}/getAllAreas`,
        });
        
        if (res && res.data) {
          this.areaBlocks = res.data.map(ele => {
            return {
              ...ele,
              no: this.getNoByArea(ele),
            };
          });
        }
      } catch (error) {
        console.error('getInstrumentsAndAreas error:', error);
        throw error; // Re-throw to be caught by init
      }
    },
    getNoByArea(area){
      console.log(area.name);
      let front = area.name.split('-')[0];
      let X = front.split('+')[0];
      let Y = front.split('+')[1];
      if(X == 'TK028') return '1602LS';
      if(X == 'TK031') return '1605LS';
      if(X == 'TK070' && Y == '700') return '2501LS';
      if(X == 'TK076' && Y == '830') return '2601LS,2602LS';
      if(X == 'TK083') return '2611LS';
      if(X == 'TK086') return '2615LS';
      if(X == 'TK088' && Y == '224') return '2633LS';
      if(X == 'TK093' && Y == '100') return '2634LS';
      else if(X == 'TK093' && Y == '541') return '2616LS';
      else if(X == 'TK093' && Y == '755') return '2617LS';
      //else if(X == 'TK93' && '889') return '2620LS';
      if(X == 'TK096') return '2620LS';
      if(X == 'TK098') return '2622LS';
      if(X == 'TK099') return '2625LS';
      if(X == 'TK100') return '2626LS(W),2627LS(E)';
      if(X == 'TK107') return '3101RF';
      if(X == 'TK117') return '3104LS';
      if(X == 'TK118') return '3106LS(N),3107LS(S)';
      if(X == 'TK123') return '3121LS';
      if(X == 'TK125' && Y == '800') return '3114LS';
      else if(X == 'TK125' && Y == '940') return '3115LS';
      if(X == 'TK126') return '3115LS';
      if(X == 'TK171') return '4101LS';
      if(X == 'TK172') return '4103LS';
      return '';
    },
    async alert(instrumentName, area){
      //console.log(text);

      const idOf = a => a._id || a.name;
      const id = idOf(area);
      const idx = this.expandedOrder.indexOf(id);

      if (idx < 0) {
        // 展開
        this.expandedOrder = [id, ...this.expandedOrder];
        this.expandedOrder = this.areaBlocks.map(a => idOf(a)).filter(a => this.expandedOrder.includes(a));
        this.$refs[area.name][0].isShow = true;
      }

      if(!this.isAudioPermission){
        console.log('無法獲取音頻權限');
      }
      
      const alertFlag = this.alertList.includes(instrumentName);

      if(alertFlag) return;

      this.alertList.push(instrumentName);
      //alert(text);
      
      console.log(`play by ${instrumentName}`);
      try{
        // 创建一个音频元素并设置音频源
        const audio = document.getElementById('audioElement');
        audio.loop = true;
        audio.load();
        // 等待音频加载
        await audio.play();
        // 如果播放成功，说明用户已经允许了音频权限
        console.log('音频播放成功，权限已获得');
        this.permissionStatus = '音訊權限已授予';
      } catch (error) {
        // 播放失败，用户可能拒绝了音频权限
        console.error('音频播放失败，可能是因为权限被拒绝', error);
        this.permissionStatus = '音訊權限未授予';
      }
      
    },
    close_alert(instrumentName){
      this.alertList = this.alertList.filter(insName => insName !== instrumentName);

      if(this.alertList.length > 0) return;

      console.log(`pause by ${instrumentName}`);
      const audio = document.getElementById('audioElement');
      audio.pause(); // 暂停音频播放
      audio.currentTime = 0; // 将播放位置重置为开头
    },
    openOCC(){
      this.requestLocationPermission();
    },
    // 是否展開：用 expandedOrder 即可
    isExpanded(area) {
      const id = area._id || area.name;
      return this.expandedOrder.includes(id);
    },
    // 由子元件觸發
    onToggle(area) {
      const idOf = a => a._id || a.name;
      const id = idOf(area);
      const idx = this.expandedOrder.indexOf(id);

      if (idx >= 0) {
        // 收合：移除
        this.expandedOrder = [
          ...this.expandedOrder.slice(0, idx),
          ...this.expandedOrder.slice(idx + 1),
        ];
      } else {
        // 展開
        this.expandedOrder = [id, ...this.expandedOrder];
        this.expandedOrder = this.areaBlocks.map(a => idOf(a)).filter(a => this.expandedOrder.includes(a));
      }
    },

    onStatusChange({ id, status }) {
      // 讓它是響應式：若用 Vue 2，建議 this.$set
      this.$set(this.areaStatusMap, id, status);
    },
    showArea(area) {
      const id = area._id || area.name;
      const status = this.areaStatusMap[id];
      // 預設顯示，只有明確是 'down' 才隱藏
      return status !== 'down';
    },
  },
};
</script>

<style lang="stylus" scoped>
.area-grid
  display: flex
  flex-wrap: wrap
  gap: 12px

.area-card
  flex: 1 1 calc(25% - 12px) // 四欄卡片
  max-width: calc(25% - 12px)
  transition: all 0.3s ease
  box-sizing: border-box
  cursor: pointer

.area-card.expanded
  flex: 1 1 100%
  max-width: 100%
</style>

